import { z } from 'zod';
import { defineEndpoint } from '../define';
import { UserEmailSchema } from './shapes';

// Self-service read: the caller's own additional emails. Auth-only.
export const getMyUserEmails = defineEndpoint({
  method: 'GET',
  path: '/v1/user-emails/mine',
  params: z.object({}),
  query: z.object({}),
  body: z.undefined(),
  response: z.object({ data: z.array(UserEmailSchema) }),
});
